export const successfulCases = [
    {
        text: "Gracias a la plataforma EanX, pude seguir con mis estudios y aprender temas de gran interés para mi futura vida laboral, en diferentes áreas. Me parece increíble la entrega de certificados al finalizar cada curso y estoy seguro que así como a mí me han ayudado mucho para mi desarrollo personal y profesional, a otras personas también.",
        name: "Andrés Felipe Echeverri",
        image: "andres-felipe-caso-exito.jpg"
    },
    {
        text: "En EanX he encontrado excelentes cursos que me han hecho sentir parte de la plataforma y de la familia eanista. Siempre seré parte de EanX y le tendré presente en cualquier formación que quiera hacer.",
        name: "Jorge Alcides Castro",
        image: "user_profile.png"
    },
    {
        text: "El curso Aprende a Perdonar con Fred Luskin me ha brindado muchos aprendizajes que no solo tienen que ver con el perdón, sino con entregar mente y cuerpo para reaccionar mejor ante cualquier situación que la vida presente. Sin duda tomar este curso es una muy buena inversión para tu vida.",
        name: "María Fernanda Millán",
        image: "maria-fernanda-millan-casos-exito.jpg"
    },
    {
        text: "Soy diseñadora gráfica hace más de diez años, el curso de Visual Storytelling con Vicente Numpaque, me dio las herramientas para comunicarme de una manera más clara y efectiva con mis clientes.",
        name: "Angie Barrera",
        image: "angie-barrera-caso-exito.jpg"
    },
]